import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../core';

declare let window: any;

@Component({
  selector: 'reject-dialog',
  templateUrl: './reject-dialog.html',
  styleUrls: ['./reject-dialog.scss']
})
export class RejectDialog implements OnInit {
  applyId: number;
  msg: string;
  agencyName!: string;
  projectName!: string;

  constructor(private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private httpService: HttpService,
  ) {

  }

  ngOnInit() {
    console.log('---reject data---', this.data);
    this.applyId = this.data.applyId;
    this.agencyName = this.data.agencyName;
    this.projectName = this.data.projectName;
  }

  cancel() {
    this.dialogRef.close();
  }

  reject() {
    const fd = {
      rejectReason: this.msg
    };
    this.httpService.rejectProjectApply(this.applyId, fd).toPromise().then((res: any) => {
      window.sa_event('project_agency_reject', {
        project_name: this.projectName,
        agency: this.agencyName
      });
      this.cancel();
    });

  }
}
